module.exports = __webpack_public_path__ + "img/no-data.183b30dd.png";